module.exports = __webpack_public_path__ + "img/prev2.a12e1f7.png";